"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.additionalDiscounts = void 0;
var qs_1 = require("qs");
exports.additionalDiscounts = function (axios) {
    return {
        getAdditionalDiscounts: function (_a) {
            var params = _a.params;
            var query = qs_1.stringify(params, { arrayFormat: 'comma' });
            return axios.get("/additional-discounts?" + query);
        },
        getadditionalDiscountsSummary: function (getadditionalDiscountsSummary) {
            return axios.get('/additional-discounts/summaries', getadditionalDiscountsSummary);
        },
        // 추가할인 등록 및 수정
        putAdditionalDiscounts: function (request) {
            return axios.put('/additional-discounts', request.data);
        },
        // 추가할인 종료
        putAdditionalDiscountsExpireDiscount: function (request) {
            return axios.put("/additional-discounts/expireDiscount/" + request.pathParams.discountNo + "?mallNo=" + request.params.mallNo);
        },
        getAdditionalDiscountDetail: function (request) {
            return axios.get("/additional-discounts/" + request.pathParams.discountNo);
        },
        getAdditionalDiscountExcel: function (getAdditionalDiscountExcelRequest) {
            return axios.get('/additional-discounts/excel', getAdditionalDiscountExcelRequest);
        },
    };
};
